<template>
  <div class="main-body">
    <div class="header">
      甘油三酯
    </div>
    <div class="out">
      <div class="search2">

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-button style="margin-left: 10px;" size="mini" type="primary" icon="el-icon-search" @click="getList2">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                :height="th" border>
        <el-table-column prop="userName" label="用户姓名"></el-table-column>
        <el-table-column prop="value" label="甘油三酯"></el-table-column>
        <el-table-column prop="deviceType" label="来源"></el-table-column>


        <el-table-column label="异常">
          <template slot-scope="scope">
            <span v-if="scope.row.isNormal == 0">异常</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" label="检查时间" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openLine(scope.row)">曲线图</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly"
             v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


    <Line2 ref="myLine2" v-show="showModalLine" v-on:closeLine="closeLine"></Line2>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyGovForReg";
import Line2 from "./Line2";

export default {
  name: "Role",
  data(){
    return{
      tableLoading:false,

      showModalGetElderly:false,
      showModalLine:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      userCode:'',
      userName:'',

    }
  },
  components:{
    Elderly,Line2
  },
  created(){
    this.init();
    this.getList2();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    init(){

    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },

    openLine(row){
      this.showModalLine = !this.showModalLine;
      this.$refs.myLine2.init(row.userCode);
    },
    closeLine(){
      this.showModalLine = !this.showModalLine;
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList2();
    },

    //日期格式
    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },


    getList2(isSearch){
      if(isSearch)this.currentPage=1

      var _this=this
      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DataAll/GovPageMul",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          deviceType: '',
          valueType:7,
          userCode:this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        _this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
